import React, { useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { addWorkingSchedule } from "../../api/Staff";
import { ToastMain, SweetAlertShow, LoadingDiv } from "../master/Master";
import { useNavigate } from "react-router-dom";
import StaffLayout from "./StaffLayout";

const ScheduleCreate = () => {
  const [loading, setLoading] = useState(false);
  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const navigate = useNavigate();

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await addWorkingSchedule(formData);
      if (response.data.status) {
        //   ToastMain.fire({
        //     icon:'success',
        //     title: response?.data?.message || 'Successfully'
        //   })
        SweetAlertShow("success", "Successfully", response?.data?.message);
        navigate("/teacher/working/schedule");
      } else {
        //  ToastMain.fire({
        //     icon:'info',
        //     title: response?.data?.message || 'something went wrong'
        //  })
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      //    ToastMain.fire({
      //     icon:'error',
      //     title: err?.response?.data?.message || 'something went wrong'
      //    })
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row">
                  <StaffLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <form onSubmit={handleAdd}>
                          <h4 className="text-primary">Working Schedule Add</h4>
                          <div className="row g-4">
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control text-capitalize input-uppercase"
                                  placeholder="Name"
                                  name="name"
                                  required
                                />
                                <label htmlFor="">Name</label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="time"
                                  className="form-control text-capitalize"
                                  name="start_time"
                                  required
                                />
                                <label htmlFor="">Start Time</label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="time"
                                  className="form-control text-capitalize"
                                  name="end_time"
                                  required
                                />
                                <label htmlFor="">End Time</label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control text-capitalize"
                                  name="late_mark"
                                  placeholder="Late Mark (in Minutes)"
                                  required
                                />
                                <label htmlFor="">Late Mark (in Minutes)</label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control text-capitalize"
                                  name="early_mark"
                                  placeholder="Early Mark (in Minutes)"
                                  required
                                />
                                <label htmlFor="">
                                  Early Mark (in Minutes)
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control text-capitalize"
                                  name="overtime_mark"
                                  placeholder="Overtime Mark (in Minutes)"
                                  required
                                />
                                <label htmlFor="">
                                  Overtime Mark (in Minutes)
                                </label>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <label htmlFor="" className="mb-2">
                                Working Days
                              </label>
                              <div className=" d-flex flex-wrap align-content-center gap-3">
                                {days.map((day) => (
                                  <div className="form-check" key={day}>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value={day}
                                      id={day}
                                      name="working_days[]"
                                      // required
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={day}
                                    >
                                      {day}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                          <button
                            type="submit"
                            className="btn btn-primary px-5"
                            disabled={loading}
                          >
                            {loading ? (
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              "Submit"
                            )}
                            {loading ? " Submitting..." : ""}
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleCreate;
